window.constants = {
  CACHE_KEY_WEEKLY_HOT_PRODUCTS: 'weeklyHotProducts',
  CACHE_KEY_HOMEPAGE: 'homepage',
}
